class AboutMap extends HTMLElement {
  static get observedAttributes() {
    return ['active-class'];
  }

  constructor() {
    super();
    this.activeClass = this.getAttribute('active-class') || 'active';
    this._observer = null;
    this._activated = false;
  }

  connectedCallback() {
    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this._activated) {
              this._activated = true;
              this.activate();
              this._observer.disconnect();
            }
          });
        },
        { threshold: 0.5 }
      );
      this._observer.observe(this);
    } else {
      this.activate();
    }
  }

  attributeChangedCallback() {
    this.activeClass = this.getAttribute('active-class') || 'active';
    if (this._activated) {
      this.activate();
    }
  }

  activate() {
    const countries = Array.from(
      this.querySelectorAll('.about-map__item[data-country]')
    );
    const svg = this.querySelector('svg') || document.querySelector('svg');
    if (!svg || !countries.length) return;

    countries.sort((a, b) => {
      const dateA = new Date(a.getAttribute('data-date'));
      const dateB = new Date(b.getAttribute('data-date'));
      return dateA - dateB;
    });

    countries.forEach((item, idx) => {
      const countryName = item.getAttribute('data-name');
      if (!countryName) return;
      // Find all matching paths in the SVG by data-name or class that matches countryName

      const svgPaths = Array.from(
        svg.querySelectorAll(
          `path[name='${countryName}'], path[class='${countryName}']`
        )
      );

      svgPaths.forEach((svgPath) => {
        setTimeout(() => {
          svgPath.classList.add(this.activeClass);
        }, idx * 45);
      });
    });
  }
}

customElements.define('about-map', AboutMap);

(function() {

const section = document.querySelector('.about-map__inner');
if (!section) return;

const observer = new IntersectionObserver(intersectionCallback, { threshold: 0.3 });
observer.observe(section);

function intersectionCallback(entries) {
  if (entries[0].isIntersecting) {
    animacjaNumerkow();
    observer.unobserve(section);
  }
}

function animacjaNumerkow() {
  const numbers = section.querySelectorAll('.about-map__number span[data-target]');
  numbers.forEach(span => {
    const target = parseInt(span.getAttribute('data-target'), 10);
    let current = 0;
    const increment = Math.max(1, Math.floor(target / 60));
    function update() {
      current += increment;
      if (current >= target) {
        span.textContent = target;
      } else {
        span.textContent = current;
        requestAnimationFrame(update);
      }
    }
    span.textContent = '0';
    update();
  });
}

})();